import React, { Component } from "react";
import { Link } from "react-router-dom";

class Copyright extends Component {
  render() {
    return (
      <div className="copyright">
        <p>
          <Link to="/" className="home-link-a"></Link>
        </p>
        <p>
          &copy;2023 <Link to="/">Anyways Here's the Thing</Link>, LLC
        </p>
      </div>
    );
  }
}

export default Copyright;



// WEBPACK FOOTER //
// ./src/components/All/Copyright.js